import { memo } from "react";

interface CartItemSmallProps {
  image: string;
  imageAlt: string;
  title: string;
  currentPrice: string;
  originalPrice?: string;
  onClick?: () => void;
}

const CartItemSmall = memo(function CartItemSmall({
  image,
  imageAlt,
  title,
  currentPrice,
  originalPrice,
  onClick,
}: CartItemSmallProps) {
  return (
    <div className="results-cart cursor-pointer" onClick={onClick}>
      <div className="h-[100px]">
        <img
          src={image}
          alt={imageAlt}
          className="w-full max-w-full max-h-full h-auto object-contain"
        />
      </div>
      <div className="results-cart-text mt-[7px]">
        <p className="mb-[7px] text-[14px] [@media(max-width:440px)]:text-[13px]">
          {title}
        </p>
        <div className="flex items-center gap-[6px]">
          <p className="text-[#797AFF] text-[16px] [@media(max-width:440px)]:text-[14px]">
            {currentPrice}
          </p>
          {originalPrice && (
            <p className="text-[#9E9E9E] text-[16px] [@media(max-width:440px)]:text-[14px]">
              <del>{originalPrice}</del>
            </p>
          )}
        </div>
      </div>
    </div>
  );
});

export default CartItemSmall;
